﻿'use strict';
require('../../../css/bootstrap.css');
require('../../../css/select.min.css');
require('../../../css/toaster.css');
require('../../../css/ionicons.css');
require('../../../css/ng-tags-input.css');
require('../../../css/ng-tags-input.bootstrap.css');



//////////////////
// WEBPACK FOOTER
// ./source/angular/app/presentation/vendorPresentation.js
// module id = 82
// module chunks = 2